<template>
  <div class="container_padding">
    <LearningPageBox>
      <template slot="title">
        <div class="justify-space-between progress_title">
          <span>{{$t('message.exam_record')}}</span>
          <mBtn
            :loading="testLoading"
            @click="handleClick"
            :disabled="$store.state.isPreview"
          >{{$t('message.start_test')}}</mBtn>
        </div>
      </template>
      <template slot="content">
        <div class="record_content">
          <el-table
            :data="recordPageData"
            stripe
            @current-change="handleCurrentChange"
            class="pointer"
          >
            <el-table-column :label="$t('message.course_name')" prop="course"></el-table-column>
            <el-table-column :label="$t('message.exam_score')" prop="totalScore" align="center"></el-table-column>
            <el-table-column :label="$t('message.operation_time')" prop="startTime" align="center">
              <template slot-scope="scope">
                <span>{{scope.row.startTime | formatDate}}</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('message.view')" width="100" align="center">
              <template>
                <img src="../../../assets/web/examine.png" width="18px" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="size"
            :total="total"
            @current-change="changePage"
          ></el-pagination>
        </div>
      </template>
    </LearningPageBox>
    <!-- <div class="record">
      <div class="record_title">{{$t('message.exam_record')}}</div>
      <div class="record_content">
        <el-table
          :data="recordPageData"
          stripe
          @current-change="handleCurrentChange"
          class="pointer"
        >
          <el-table-column :label="$t('message.course_name')" prop="course"></el-table-column>
          <el-table-column :label="$t('message.exam_score')" prop="totalScore" align="center"></el-table-column>
          <el-table-column :label="$t('message.operation_time')" prop="startTime" align="center">
            <template slot-scope="scope">
              <span>{{scope.row.startTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.view')" width="50" align="center">
            <template>
              <img src="../../../assets/web/examine.png" width="18px" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="size"
          :total="total"
          @current-change="changePage"
        ></el-pagination>
      </div>
    </div>-->
  </div>
</template>

<script>
import UserAssessmentsAPI from "../../../api/UserAssessmentsAPI";
import CourseAPI from "../../../api/CourseAPI";
import LearningPageBox from "../../../components/LearningPageBox";
import mBtn from "../../../components/mBtn";
export default {
  components: { LearningPageBox, mBtn },
  data() {
    return {
      loading: false,
      testLoading: false,
      record: [],
      page: 1,
      size: 10,
      total: 0
    };
  },
  computed: {
    recordPageData() {
      const record = JSON.parse(JSON.stringify(this.record));
      const page = this.page;
      const size = this.size;
      let pageData = [];
      if (record.length > 0) {
        pageData = record.slice((page - 1) * size, page * size);
      }
      return pageData;
    }
  },
  methods: {
    // 分頁
    changePage(val) {
      this.page = val;
    },
    // 選擇記錄
    handleCurrentChange(val) {
      this.$store.commit("changTestResult", val);
      this.$router.push({
        path: "/learning/testresult",
        query: {
          resultId: val.id,
          resultCourseId: val.courseVersionId,
        }  
      });
    },
    // 開始考試
    handleClick() {
      const courseId = sessionStorage.getItem("courseId");
      const lang = this.$i18n.locale;
      this.testLoading = true;
      CourseAPI.getOne(courseId, lang)
        .then(res => {
          if (res.progress <= 0.8) {
            this.testLoading = false;
            this.$alert(this.$t("message.test_tips"), this.$t("message.tips"), {
              confirmButtonText: this.$t("message.confirm"),
              callback: action => {
                console.log(action);
              }
            });
          } else {
            UserAssessmentsAPI.assessment(courseId, lang)
              .then(res => {
                this.testLoading = false;
                sessionStorage.setItem("testing", true);
                sessionStorage.setItem("questionCount", res.questionCount);
                sessionStorage.setItem("questionNum", 0);
                this.$router.push({
                  path: "/learning/test"
                });
                console.log(res);
              })
              .catch(err => {
                this.testLoading = false;
                this.$error(err);
                console.log(err);
              });
          }
        })
        .catch(err => {
          this.testLoading = false;
          this.$error(err);
          console.log(err);
        });
    },
    get() {
      this.loading = true;
      const courseId = sessionStorage.getItem("courseId");
      UserAssessmentsAPI.findByCourse(courseId, this.$i18n.locale)
        .then(res => {
          // console.log(res);
          if (res) {
            this.loading = false;
            this.record = res.reverse();
            this.total = res.length;
          }
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          console.log(err);
        });
    }
  },
  created() {
    this.get();
  }
};
</script>

<style lang="scss" scoped>
.record_content {
  min-height: 500px;
}
</style>